// extracted by mini-css-extract-plugin
export default {"section":"DeptTab_section__J-hZA","title":"DeptTab_title__S1nyq"};